/* product-gallery.js — loaded on product pages only via theme.liquid
   Adds: gallery prev/next arrows + click-to-enlarge lightbox
   Depends on: galleryImages[] defined in theme.liquid conditional block
   currentGalleryIndex is a global synced across this file and theme.liquid inline script */

(function () {
  'use strict';

  var currentIdx = 0;

  /* ── Lightbox ──────────────────────────────────────────────── */
  function buildLightbox() {
    if (document.getElementById('pg-lightbox')) return;
    var lb = document.createElement('div');
    lb.id = 'pg-lightbox';
    lb.style.cssText = 'display:none;position:fixed;inset:0;background:rgba(0,0,0,0.92);z-index:9999;align-items:center;justify-content:center;cursor:zoom-out;';
    lb.innerHTML =
      '<button id="pg-lb-prev" aria-label="Previous" style="position:absolute;left:1rem;top:50%;transform:translateY(-50%);background:rgba(255,255,255,0.15);border:none;border-radius:50%;width:3rem;height:3rem;display:flex;align-items:center;justify-content:center;cursor:pointer;color:#fff;transition:background 0.2s;">' +
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><polyline points="15 18 9 12 15 6"/></svg></button>' +
      '<img id="pg-lb-img" src="" alt="" style="max-width:90vw;max-height:90vh;object-fit:contain;border-radius:0.5rem;pointer-events:none;">' +
      '<button id="pg-lb-next" aria-label="Next" style="position:absolute;right:1rem;top:50%;transform:translateY(-50%);background:rgba(255,255,255,0.15);border:none;border-radius:50%;width:3rem;height:3rem;display:flex;align-items:center;justify-content:center;cursor:pointer;color:#fff;transition:background 0.2s;">' +
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><polyline points="9 6 15 12 9 18"/></svg></button>' +
      '<button id="pg-lb-close" aria-label="Close lightbox" style="position:absolute;top:1rem;right:1rem;background:rgba(255,255,255,0.15);border:none;border-radius:50%;width:3rem;height:3rem;display:flex;align-items:center;justify-content:center;cursor:pointer;color:#fff;font-size:1.5rem;line-height:1;">&times;</button>';
    document.body.appendChild(lb);

    lb.addEventListener('click', function (e) { if (e.target === lb) closeLightbox(); });
    document.getElementById('pg-lb-close').addEventListener('click', closeLightbox);
    document.getElementById('pg-lb-prev').addEventListener('click', function (e) { e.stopPropagation(); lbNav(-1); });
    document.getElementById('pg-lb-next').addEventListener('click', function (e) { e.stopPropagation(); lbNav(1); });

    // Hover tint on arrow buttons
    ['pg-lb-prev','pg-lb-next','pg-lb-close'].forEach(function(id) {
      var btn = document.getElementById(id);
      btn.addEventListener('mouseover', function(){ this.style.background = 'rgba(255,255,255,0.3)'; });
      btn.addEventListener('mouseout',  function(){ this.style.background = 'rgba(255,255,255,0.15)'; });
    });
  }

  function openLightbox(idx) {
    var imgs = window.galleryImages || [];
    if (!imgs.length) return;
    currentIdx = (idx || 0);
    window.currentGalleryIndex = currentIdx;
    var lb = document.getElementById('pg-lightbox');
    var img = document.getElementById('pg-lb-img');
    if (!lb || !img) return;
    img.src = imgs[currentIdx];
    lb.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    // Hide nav buttons when only one image
    var showNav = imgs.length > 1;
    document.getElementById('pg-lb-prev').style.display = showNav ? 'flex' : 'none';
    document.getElementById('pg-lb-next').style.display = showNav ? 'flex' : 'none';
  }

  function closeLightbox() {
    var lb = document.getElementById('pg-lightbox');
    if (lb) lb.style.display = 'none';
    document.body.style.overflow = '';
  }

  function lbNav(dir) {
    var imgs = window.galleryImages || [];
    if (!imgs.length) return;
    currentIdx = (currentIdx + dir + imgs.length) % imgs.length;
    window.currentGalleryIndex = currentIdx;
    document.getElementById('pg-lb-img').src = imgs[currentIdx];
    syncGallery(currentIdx);
  }

  /* ── Gallery arrow buttons (injected into DOM) ─────────────── */
  function buildArrows(wrapper) {
    if (wrapper.querySelector('.pg-arrow')) return;

    function makeArrow(dir, points) {
      var btn = document.createElement('button');
      btn.className = 'pg-arrow';
      btn.setAttribute('aria-label', dir > 0 ? 'Next image' : 'Previous image');
      btn.style.cssText = (dir < 0 ? 'left:0.75rem;' : 'right:0.75rem;') +
        'position:absolute;top:50%;transform:translateY(-50%);background:rgba(255,255,255,0.9);border:none;border-radius:50%;width:2.5rem;height:2.5rem;display:flex;align-items:center;justify-content:center;cursor:pointer;z-index:2;box-shadow:0 2px 8px rgba(0,0,0,0.15);transition:background 0.2s;';
      btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><polyline points="' + points + '"/></svg>';
      btn.addEventListener('click', function () { galleryNav(dir); });
      btn.addEventListener('mouseover', function () { this.style.background = '#fff'; });
      btn.addEventListener('mouseout',  function () { this.style.background = 'rgba(255,255,255,0.9)'; });
      return btn;
    }

    wrapper.appendChild(makeArrow(-1, '15 18 9 12 15 6'));
    wrapper.appendChild(makeArrow(1,  '9 6 15 12 9 18'));
  }

  /* ── Gallery navigation (arrow clicks) ─────────────────────── */
  function galleryNav(dir) {
    var imgs = window.galleryImages || [];
    if (!imgs.length) return;
    currentIdx = (currentIdx + dir + imgs.length) % imgs.length;
    window.currentGalleryIndex = currentIdx;
    var mainImg = document.getElementById('gallery-main-img');
    if (mainImg) mainImg.src = imgs[currentIdx];
    syncGallery(currentIdx);
  }

  function syncGallery(idx) {
    document.querySelectorAll('.gallery-thumb').forEach(function (t, i) {
      t.style.borderColor = (i === idx) ? 'var(--ocean-500)' : 'transparent';
    });
  }

  /* ── Keyboard support ───────────────────────────────────────── */
  document.addEventListener('keydown', function (e) {
    var lb = document.getElementById('pg-lightbox');
    if (!lb || lb.style.display !== 'flex') return;
    if (e.key === 'ArrowLeft')  lbNav(-1);
    if (e.key === 'ArrowRight') lbNav(1);
    if (e.key === 'Escape')     closeLightbox();
  });

  /* ── Patch thumbnail clicks to track currentIdx ─────────────── */
  function patchThumbs() {
    document.querySelectorAll('.gallery-thumb').forEach(function (btn, i) {
      var orig = btn.onclick;
      btn.onclick = function (e) {
        if (orig) orig.call(this, e);
        currentIdx = i;
        window.currentGalleryIndex = i;
      };
    });
  }

  /* ── Init on DOM ready ──────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    var mainImg = document.getElementById('gallery-main-img');
    if (!mainImg) return; // not a product page

    var imgs = window.galleryImages || [];

    // 1. Apply contain + zoom cursor via JS (CSS override in theme.liquid is primary)
    mainImg.style.objectFit = 'contain';
    mainImg.style.cursor = imgs.length ? 'zoom-in' : 'default';

    // 2. Open lightbox on main image click
    mainImg.addEventListener('click', function () {
      openLightbox(currentIdx);
    });

    // 3. Build lightbox overlay
    buildLightbox();

    // 4. Inject arrows if multiple images
    if (imgs.length > 1) {
      buildArrows(mainImg.parentElement);
    }

    // 5. Patch thumb buttons to sync currentIdx
    patchThumbs();

    // 6. Expose openLightbox globally (in case any inline onclick uses it)
    window.openLightbox = openLightbox;
    window.closeLightbox = closeLightbox;
    window.galleryNav = galleryNav;
    window.currentGalleryIndex = currentIdx;
  });
})();
